import React from 'react';
import ReactDOM from 'react-dom';
import {
  HashRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import ReactGA from 'react-ga';
import { Motion, spring } from 'react-motion';
import classNames from 'classnames';

import BRAND from './brand';
import NavBar from './components/nav-bar';
import ScrollPager from './components/scroll-pager';
import Home from './components/page-home';
import ProjectList from './components/page-project-list';
import About from './components/page-about';
import Contact from './components/page-contact';
import Logo from './components/logo';

require ('./index.scss');

ReactGA.initialize("UA-101653463-1", { });

const pages = [
  { name: 'Home', url: '/', color:BRAND.red, menu: false },
  { name: 'Projects', url: '/projects', color:BRAND.red, menu: true },
  { name: 'About', url: '/about', color:BRAND.red, menu: true },
  { name: 'Contact', url: '/contact', color:BRAND.red, menu: true },
  { name: 'Wallpaper', url: 'http://jqlynandco.com/', menu: true }
];

const mediaLinks = [
  { name: 'Instagram',
    url: 'https://www.pinterest.com/jqlynmoore/'},
  { name: 'Facebook',
    url: 'https://www.facebook.com/jmhinteriordesign/'},
  { name: 'Pinterest',
    url: 'https://www.pinterest.com/jqlynmoore/'}
]

const history = createHistory();
history.listen((location, action) => {
  console.log("Got new page");
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});


const App = () => {
  const navLinks = pages.reduce ((acc, curr) => {
    if (curr.menu == true) {
      acc.push({ name: curr.name, url: curr.url })
    }
    return acc;
  }, []);

  const mobileItems = (
    <div className="app--media-links">
      { mediaLinks.map ((item, index) => (
        <div className="app--social-media"
          key={index}
        >
          <a href={item.url} target="_blank">
            {item.name}
          </a>
        </div>
      )) }
    </div>
  );


  return (
    <Router history={history}>
      <Route render={({ location }) => {
        const curPage  = pages.find (item => item.url === location.pathname);
        const color = curPage != undefined ? curPage.color : BRAND.red;
        const logoStyle = {
          fill: color,
          stroke: 'none'
        };

        // Hide the logo on the home page
        const hideLogo = { 'hide' : location.pathname === '/' };

        return (
          <ScrollPager>
            <NavBar
              links={navLinks}
              location={location}
              mobileItems={mobileItems}
              color={color}
            >
              <div className={classNames ('app--logo-container', hideLogo)}>
                <Link to="/">
                  <Logo style={logoStyle} className="app--logo"/>
                </Link>
              </div>
            </NavBar>
            <Route exact path="/" location={location} component={Home}/>
            <Route path="/projects" location={location} component={ProjectList}/>
            <Route path="/about" location={location} component={About}/>
            <Route path="/contact" location={location} component={Contact}/>
          </ScrollPager>
        )
      }}/>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById ('app'));



// WEBPACK FOOTER //
// ./index.js